import { render, staticRenderFns } from "./moreHonor.vue?vue&type=template&id=28cc4230&scoped=true"
import script from "./moreHonor.vue?vue&type=script&lang=js"
export * from "./moreHonor.vue?vue&type=script&lang=js"
import style0 from "./moreHonor.vue?vue&type=style&index=0&id=28cc4230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc4230",
  null
  
)

export default component.exports